var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"warning-color quota-message"},[_vm._v(_vm._s(_vm.$t('system.text_24')))])
}
var staticRenderFns = []

export { render, staticRenderFns }